export const setData = (value: any) => {
  return {
    type: 'SET_DATA',
    value,
  };
};

export const modData = (value: any) => {
  return {
    type: 'MODIFY_DATA',
    value,
  };
};
